import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedLegModule, SharedModule } from '@approot/shared';
import { RfqQuoteComponent } from '@approot/shared/custom-components/rfq-quotes/rfq-quote.component';
import { AgGridModule } from 'ag-grid-angular';
import { QuoteFilterByProviderPipe } from './pipes/quote-filter-by-bank.pipe';
import { QuoteTimeLimitFilterPipe } from './pipes/quote-time-limit-filter.pipe';
import { RfqContainerComponent } from './rfq-container/rfq-container.component';
import { RfqDialogComponent } from './rfq-container/rfq-dialog/rfq-dialog.component';
import { RfqOfferFormatterComponent } from './rfq-container/rfq-offer-formatter/rfq-offer-formatter.component';
import { MifidChecksComponent } from './rfq-container/rfq-tab/mifid-checks/mifid-checks.component';
import { RfqBookTradesComponent } from './rfq-container/rfq-tab/rfq-book-trades/rfq-book-trades.component';
import { RfqMultiHedgeGroupComponent } from './rfq-container/rfq-tab/rfq-multi-hedge-group/rfq-multi-hedge-group.component';
import { RfqMultiHedgeComponent } from './rfq-container/rfq-tab/rfq-multi-hedge/rfq-multi-hedge.component';
import { RfqPricesComponent } from './rfq-container/rfq-tab/rfq-prices/rfq-prices.component';
import { RfqSetupComponent } from './rfq-container/rfq-tab/rfq-setup/rfq-setup.component';
import { RfqTabComponent } from './rfq-container/rfq-tab/rfq-tab.component';
import { RfqTimelineComponent } from './rfq-timeline/rfq-timeline.component';

@NgModule({
  declarations: [
    RfqSetupComponent,
    RfqPricesComponent,
    RfqContainerComponent,
    RfqTabComponent,
    QuoteTimeLimitFilterPipe,
    QuoteFilterByProviderPipe,
    RfqMultiHedgeComponent,
    RfqMultiHedgeGroupComponent,
    RfqBookTradesComponent,
    RfqQuoteComponent,
    MifidChecksComponent,
    RfqDialogComponent,
    RfqTimelineComponent,
    RfqOfferFormatterComponent
  ],
  imports: [
    SharedModule,
    SharedLegModule,
    FormsModule,
    ReactiveFormsModule,
    AgGridModule
  ],
  exports: [
    RfqSetupComponent,
    RfqPricesComponent,
    RfqContainerComponent,
    RfqTabComponent,
    RfqQuoteComponent,
    QuoteTimeLimitFilterPipe,
    QuoteFilterByProviderPipe,
    RfqTimelineComponent,
    RfqOfferFormatterComponent
  ]
})
export class RfqModule {}
